import { PaginatedRequest } from "../../../common/paginated-request/paginated-request.dto";

export class GetAdminAccountsRequest extends PaginatedRequest {
    
}